module.exports = __webpack_public_path__ + "79bd759ca877588ea722ac99c45b1473.svg";